var map = {
	"./en.ts": [
		"76aa",
		"i18n/en-ts"
	],
	"./i18n.ts": [
		"4a4f"
	],
	"./ru.ts": [
		"4f8d",
		"i18n/ru-ts"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "2666";
module.exports = webpackAsyncContext;